import React, { Component } from "react";
import { Card, CardHeader, CardBody } from "reactstrap";
import axios from "axios";
import { Redirect } from "react-router";
import * as API_LINKS from "../../../redux/config/links";
import LiveMonitoringDatatable from "./Datatable";
import { compose } from "recompose";
import customMarkerIdle from "../../../assets/img/truckidle.png";
import customMarkerMoving from "../../../assets/img/truckmoving.png";
import logoAutoma from "../../../assets/img/brand/new-automa-logo.png";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow,
  KmlLayer,
  TrafficLayer,
} from "react-google-maps";
import { BarLoader } from "react-spinners";

function generateRandom() {
  return Math.random() * 10000000000000000;
}

// Fungsi untuk menghitung zoom level berdasarkan radius dalam meter
function calculateZoomLevel(radius) {
  const scale = radius / 500; // 500 meter adalah jarak yang ditetapkan oleh Google Maps
  return Math.round(16 - Math.log(scale) / Math.log(2));
}

const MapWithAMarker = compose(
  withScriptjs,
  withGoogleMap
)((props) => {
  if (!props.markers || props.markers.length === 0) {
    return <BarLoader color={"#123abc"} loading={props.isLoading} />;
  }
  return (
    <GoogleMap
      defaultZoom={calculateZoomLevel(100)}
      defaultCenter={{
        lat: props.markers[0].lat,
        lng: props.markers[0].lng,
      }}
    >
      <KmlLayer
        url={props.kmlLink + "&ver=" + generateRandom()}
        options={{ preserveViewport: true }}
      />
      <TrafficLayer autoUpdate />
      {props.markers.map((marker) => {
        const onClick = props.onClick.bind(this, marker);
        return (
          <Marker
            key={marker.id}
            onClick={onClick}
            options={
              marker.wrn > 0
                ? marker.spd > 3.5
                  ? { icon: customMarkerMoving }
                  : { icon: customMarkerIdle }
                : { icon: customMarkerIdle }
            }
            position={{ lat: marker.lat, lng: marker.lng }}
          >
            {props.selectedMarker.id === marker.id && (
              <InfoWindow>
                <div>
                  Reg. No: {marker.fleet_id}
                  <br />
                  Speed: {marker.spd} KM/h
                  <br />
                  Last Update: {marker.time}
                </div>
              </InfoWindow>
            )}
          </Marker>
        );
      })}
    </GoogleMap>
  );
});

var refreshInterval;

class LiveMonitoring extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      liveMonitoringData: [],
      mapsMarkerData: [],
      markers: [],
      selectedMarker: false,
      success: false,
      isTokenActive: true,
    };
  }

  UNSAFE_componentWillMount = () => {
    this.getLiveMonitoringData();
    refreshInterval = setInterval(() => {
      this.getLiveMonitoringData();
    }, 300000);
  };

  componentWillUnmount() {
    clearInterval(refreshInterval);
  }

  getLiveMonitoringData = () => {
    var self = this;

    this.setState({
      isLoading: true,
      success: false,
    });

    axios({
      method: "post",
      url: API_LINKS.LIVE_MONITORING_URL, //Should Change Link later
      data: {
        share_data: this.props.match.params.key,
      },
    })
      .then((response) => {
        self.setState({
          liveMonitoringData: response.data.result,
          isLoading: false,
          success: true,
        });
        self.mapsMarkertoArray();
      })
      .catch(function () {
        self.setState({
          isTokenActive: false,
        });
      });
  };

  mapsMarkertoArray = () => {
    var list = [];
    if (this.state.liveMonitoringData !== []) {
      var liveMonitoringData = this.state.liveMonitoringData;

      liveMonitoringData.forEach((p, index) => {
        if (
          liveMonitoringData[index].lat !== null ||
          liveMonitoringData[index].lng !== null
        ) {
          var data = {
            id: liveMonitoringData[index].id,
            fleet_id: liveMonitoringData[index].reg_number,
            lat: liveMonitoringData[index].lat,
            lng: liveMonitoringData[index].lng,
            spd: liveMonitoringData[index].spd,
            wrn: liveMonitoringData[index].wrn,
            time: liveMonitoringData[index].time,
          };
          list.push(data);
        }
      });
    }
    this.setState({ markers: list });
    this.setState({
      isLoading: false,
    });
  };

  // drawMarker = () => {
  //     const {mapsMarkerData} = this.state

  //     return (
  //         <div>
  //             {this.state.markers.map((marker, index) => (
  //             // <Marker key={index} lat={marker[0]} lng={marker[1]} />
  //             <InfoWindow
  //                 key={index}
  //                 lat={marker[0].lat}
  //                 lng={marker[1].lng}
  //                 content={marker[3].fleet_id}
  //                 />
  //             ))}
  //         </div>
  //     )
  // }

  handleClick = (marker, event) => {
    // console.log({ marker })
    this.setState({ selectedMarker: marker });
  };

  onIdFleetClicked = (row) => {
    this.setState({
      selectedMarker: Object.assign(
        {},
        {
          fleet_id: row.reg_number,
          id: row.id,
          lat: row.lat,
          lng: row.lng,
          spd: row.spd,
          time: row.time,
          wrn: row.wrn,
        }
      ),
    });
  };

  render() {
    const { isTokenActive } = this.state;
    return (
      <div className="animated fadeIn">
        {isTokenActive ? (
          <Card>
            <CardHeader className="d-flex justify-content-between align-items-center">
              <img
                src={logoAutoma}
                alt="Automa_logo"
                style={{ maxWidth: "11em", height: "auto", width: "10em" }}
              />
              <h5 className="text-header" style={{ color: "#1a4e8e" }}>
                <strong>
                  Live Monitoring <br></br>({this.props.match.params.company})
                </strong>
              </h5>
            </CardHeader>
            <CardBody>
              <div>
                <MapWithAMarker
                  selectedMarker={this.state.selectedMarker}
                  markers={this.state.markers}
                  onClick={this.handleClick}
                  googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCmIATqobqbCEU90nYtwd-PzCcj8EVOlDg&v=3.exp&libraries=geometry,drawing,places"
                  loadingElement={<div style={{ height: `100%` }} />}
                  containerElement={<div style={{ height: `400px` }} />}
                  mapElement={<div style={{ height: `100%` }} />}
                  kmlLink={""}
                  loading={this.state.isLoading}
                />
              </div>
              <br />
              <div>
                <LiveMonitoringDatatable
                  liveMonitoringData={this.state.liveMonitoringData}
                  onIdFleetClicked={this.onIdFleetClicked}
                />
              </div>
            </CardBody>
          </Card>
        ) : (
          <Redirect to="/" />
        )}
      </div>
    );
  }
}

export default LiveMonitoring;



// WEBPACK FOOTER //
// ./src/views/Transporter/LiveTrackerExtn/Map.jsx